var $f114294b0561f201$exports = {};
$f114294b0561f201$exports = {
    "help": `Hj\xe6lp`,
    "info": `Oplysninger`
};


export {$f114294b0561f201$exports as default};
//# sourceMappingURL=da-DK.mjs.map
